export default __webpack_public_path__ + "static/media/logo-grey.a8fed2df.png";